export default "__VITE_ASSET__5a7b8d27__"